import { memo, useMemo } from 'react'
import { MemoComponentWrapper } from '../main/RouteWrapper'
import { classNames, Title, Body } from '@panwds/react-ui'
import { getState } from '../../framework/states'
import { PANWDS_TW2_CLS } from '../../patches/panwds-constants'
import { renderTitle } from '../main/ui-lib/utils'
import history from '../../framework/history'
import type { ReactNode, VFC } from 'react'
import type { NavItem } from '../../framework/microAppTypes'

type ComponentWrapperProps = {
  navItem: NavItem
}
export const ComponentWrapper: VFC<ComponentWrapperProps> = ({ navItem }) => {
  const { contentClassName, path } = navItem
  const cls = useMemo(() => classNames(
    !(contentClassName && /\bpanwds-(?:tw3|mixed)\b/.test(contentClassName)) && PANWDS_TW2_CLS, // tw2 by default now
    contentClassName,
  ), [contentClassName])

  return (
    <div className={cls} data-path={path}>
      <MemoComponentWrapper
        navItem={navItem}
        hasParent={true}
        renderProps={{
          // location,
          history,
          location: history.location, // TODO: tmp
        }}
        parentProps={{
          state: getState(), // TODO: tmp
        }}
      />
    </div>
  )
}

export type PageHeaderProps = {
  title: ReactNode
  subtitle?: ReactNode
  dataTestId?: string
}
const PageHeaderComp: VFC<PageHeaderProps> = ({ title, subtitle, dataTestId = 'sparky-page-header' }) => {
  const renderedTitle = renderTitle(title)
  return (
    <div className='tw-p-4 tw-font-lato tw-flex tw-justify-between tw-items-center' data-testid={dataTestId}>
      <div className='tw-flex tw-flex-col'>
        {/* breadcrumbs */}
        <div className='tw-flex tw-items-center tw-space-x-1'>
          <Title level={1} size='sm' dataTestId={`${dataTestId}-title`}>
            {renderedTitle}
          </Title>
        </div>
        {subtitle && (
          <Body
            addClassName='tw-mt-1'
            appearance='secondary'
            size='sm'
            dataTestId={`${dataTestId}-subtitle`}
          >{subtitle}</Body>
        )}
      </div>
    </div>
  )
}
export const PageHeader = memo(PageHeaderComp)
